export default __webpack_public_path__ + "static/media/michael_levitt.906082fb.jpg";